import Vue from "vue";
import PortalVue from "portal-vue";

export default () => {
  Vue.use(PortalVue);
};
